import React, {useState, useEffect} from 'react';
import './Informacion.css';
import api from '../../../services/api';
import swal from 'sweetalert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faClipboard } from '@fortawesome/free-solid-svg-icons'
import studentImage from '../../../images/student_portrait.svg'

const Informacion = () => {
    const [showInfo, setShowInfo] = useState(false);
    const [infoAlumno, setInfoAlumno] = useState([]);
    const [fotoAlumno, setFotoAlumno] = useState();

    const [showSearch, setShowSearch] = useState(false);
    const [listaAlumnos, setListaAlumnos] = useState([]);
    const [alumno, setAlumno] = useState([]);
    
    const [alumnoSeleccionado, setAlumnoSeleccionado] = useState([]);


    useEffect(() => {

        const fotoAlumno = async () => {
            try {
                const MATRICULA = alumnoSeleccionado.MATRICULA;
                const response = await api.getFotoAlumno({MATRICULA});
                const FOTO = response.data.data.FOTO;

                const arrayBuffer = new Uint8Array(FOTO.data);
                const base64String = btoa(
                  arrayBuffer.reduce((data, byte) => data + String.fromCharCode(byte), '')
                );
                setFotoAlumno(`data:image/jpeg;base64,${base64String}`);
            } catch (error) {
                setFotoAlumno(studentImage);

            }
        };

        try {
            fotoAlumno();
        } catch (error) {
        }

        
    }, [alumnoSeleccionado]);

    const seleccionarAlumno = async (alumno) => {
        const MATRICULA = alumno.MATRICULA;
        const response = await api.getInfoAlumnoCompleta({MATRICULA});
        setAlumnoSeleccionado(response.data.data);
        setShowSearch(false);   
    }

    const buscarAlumno = async () => {
        setShowSearch(true);    
        try {
            const response = await api.getAlumnosAsistencias({alumno});
            setListaAlumnos(response.data.data);
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
        }
    }


    return (
        <>
        <div className= "seccion-materias hover-seccion fade-in">
            <div className= "seccion-centro-informacion">
                <div>
                    <label htmlFor='student-name'>Nombre del Alumno:</label>
                    <input type='text' name='student-name' value={alumno} onChange={e => {setAlumno(e.target.value)}}
                        style={{fontSize: '20px', height: '20px'}}></input>
                </div>
                <div className='buscar-envio-mensaje'>
                    <button onClick={buscarAlumno} className='button-buscar-alumno'>BUSCAR ALUMNO</button>
                </div>
            </div>
            <div className='container-informacion'>
                <div className='titulo-informacion'>
                    <h3>INFORMACIÓN DEL ALUMNO</h3>
                </div>
                <hr></hr>
                <div className='container-data-reporte'>
                    <div className="data-alumno-reporte">
                        <div className='data-info-alumno-reporte-img'>
                            <img src={fotoAlumno} alt="foto-alumno-reporte" />
                        </div>
                        <label>Matricula: <p>{alumnoSeleccionado.MATRICULA}</p></label>
                        <label>Nombre: <p>{alumnoSeleccionado.NOMBRE}</p></label>
                        <label>Turno: <p>{alumnoSeleccionado.NIVEL}</p></label>
                        <label>Grado y Grupo: <p>{alumnoSeleccionado.ID_GRADO + " " + alumnoSeleccionado.GRUPO}</p></label>
                    </div>
                    <div className="container-info-alumno-reporte">
                        <div className="data-info-alumno-reporte">
                            <h3>Datos del Padre</h3>
                            <label>Nombre: <p>{alumnoSeleccionado.NOMBRE_PADRE}</p></label>
                            <label>Profesión: <p>{alumnoSeleccionado.PROFESION_PADRE}</p></label>
                            <label>Trabajo: <p>{alumnoSeleccionado.TRABAJO_PADRE}</p></label>
                            <label>Teléfono: <p>{alumnoSeleccionado.TELEFONO_PADRE}</p></label>
                        </div>
                        <div className="data-info-alumno-reporte">
                            <h3>Datos de la Madre</h3>
                            <label>Nombre: <p>{alumnoSeleccionado.NOMBRE_MADRE}</p></label>
                            <label>Profesión: <p>{alumnoSeleccionado.PROFESION_MADRE}</p></label>
                            <label>Trabajo: <p>{alumnoSeleccionado.TRABAJO_MADRE}</p></label>
                            <label>Teléfono: <p>{alumnoSeleccionado.TELEFONO_MADRE}</p></label>
                        </div>
                        <div className="data-info-alumno-reporte">
                            <h3>Domicilio Familiar</h3>
                            <label>Calle y Número: <p>{alumnoSeleccionado.DOMICILIO}</p></label>
                            <label>Colonia y CP: <p>{alumnoSeleccionado.COLONIA + " " + alumnoSeleccionado.CP}</p></label>
                            <label>Localidad: <p>{alumnoSeleccionado.LOCALIDAD}</p></label>
                            <label>Teléfono Casa: <p>{alumnoSeleccionado.TELEFONO_CASA}</p></label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        { showSearch ? <>
            <div className="overlay"></div>
            <div className='container-buscar-alumno'>
                <div className='title-buscar-alumno'>
                    <h3>SELECCIONA AL ALUMNO</h3>
                    <label className='button-close-buscar-alumno' onClick={e => setShowSearch(false)}> X </label>
                </div>
                <div className='container-table-buscar-alumno'>
                    <table className='table-buscar-alumno'>
                        <thead>
                            <tr>
                                <th><label>MATRICULA</label></th>
                                <th><label>ALUMNO</label></th>
                                <th><label>TURNO</label></th>
                                <th><label>GRADO</label></th>
                                <th><label>GRUPO</label></th>
                            </tr>
                        </thead>
                        <tbody>
                            { listaAlumnos && listaAlumnos.map( (alumno, i) => { 
                                return (
                                <tr key={ i } onClick={e => seleccionarAlumno(alumno)}>
                                    <td>{ alumno.MATRICULA }</td>
                                    <td>{ alumno.ALUMNO }</td>
                                    <td>{ alumno.NIVEL }</td>
                                    <td>{ alumno.ID_GRADO }</td>
                                    <td>{ alumno.GRUPO }</td>
                                </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </> : ''}
        </>
    );
};

export default Informacion;